import React from 'react';

import withWidth from '@material-ui/core/withWidth';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import './App.css';

import Heading from './components/Heading';
import Image from './components/Image';
import Swatches from './components/Swatches';
import SearchInput from './components/SearchInput';
import UploadButton from './components/UploadButton';

import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-NV67WG6'
}

TagManager.initialize(tagManagerArgs)

interface Props {
  width: string
}

interface State {
  image: string;
  colors: string[];
  hasError: boolean;
}
const defaultImgPreview: string = "img_default.jpg";

class AppColorExtractor extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      image: defaultImgPreview,
      colors: [],
      hasError: false
    }
}

buttonEventListener = (event: MouseEvent) => {
  const uploader = document.getElementById('uploader')
  if (uploader) {
    uploader.click()
  }
  event.preventDefault();
}

  componentDidMount(): void {
    const button: HTMLElement | null = document.getElementById('file-upload')
    button!.addEventListener('click', this.buttonEventListener);
  }

  componentWillUnmount(): void {
    document.removeEventListener('click', this.buttonEventListener);
  }

  uploadFiles = (event: React.SyntheticEvent<HTMLInputElement>) => {
    const target= event.target as HTMLInputElement;
    const file: File = (target.files as FileList)[0];
    this.setState({
      image: window.URL.createObjectURL(file),
      hasError: false,
    })
  }
  
  getColors = (colors: any) => {
    this.setState(state => ({ colors: [...colors], hasError: false }))
  }

  handleImage = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.isResponseOk(event.target.value)
    this.setState({ image: event.target.value })
  }

  isResponseOk = (path: string) =>
    fetch(path)
      .then(
        res => (res.status === 200 ? this.setState({ hasError: false }) : null)
      )
      .catch(err => (err ? this.setState({ hasError: true }) : null))

  render() {
    const { width } = this.props;

    return (
      <Container maxWidth="md">
        <Box px={width === 'xs' ? 0 : 6}>
          <Heading>
            <Grid
              container
              spacing={0}
              direction="column"
              justify="center"
              alignItems="center"
            >
              <Grid item xs={12}>
                <UploadButton uploadFiles={this.uploadFiles} />
              </Grid>
              <Grid item xs={12}>
                <SearchInput
                  imagePath={this.state.image === defaultImgPreview ? '' : this.state.image}
                  handleImage={this.handleImage}
                  getColors={this.getColors}
                  />
              </Grid>
            </Grid>
          </Heading>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={7}>
              <Image
                error={this.state.hasError}
                image={this.state.image}
                getColors={this.getColors}
                onError={error => this.setState({ hasError: true })}
              />
            </Grid>
            <Grid item xs={12} sm={5}>
              <div>
                {this.state.colors.length > 0 ? (
                  <Swatches colors={this.state.colors} />
                ) : null}
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>
    )
  }

}

export default withWidth()(AppColorExtractor);
